<template>
  <div id="issueDetailItemComp" @click="$emit('click')">
    <div class="top">
      <div class="info">
        <div class="user">
          <template v-if="detail.user">
            <van-image class="avatar" :src="detail.user.avatar" fit="cover" round ></van-image>
            <span class="name text-ellipsis">{{ detail.user.name ||detail.user.username}}</span>
          </template>
        </div>
        <div class="date">{{detail.createTime | formatDate('yyyy年MM月dd日')}}</div>
      </div>
      <div class="textarea">{{detail.contentText || (detail.content&&'图文内容')}}</div>
    </div>
    <div class="bottom">
      <div class="icons">
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_zan_01.png')" />
          <span>{{detail.likes}}</span>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_comment_01.png')" />
          <span>{{detail.comments}}</span>
        </div>
        <div class="item">
          <img class="icon" :src="require('@/assets/images/issue/icon_star_01.png')" />
          <span>{{detail.comments}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IssueDetailItemComp',
  props: {
    detail: {
      type: Object,
      default () {
        return {};
      }
    }
  }
};
</script>

<style lang="less" scoped>
#issueDetailItemComp {
  padding: 40px 28px;
  min-height: 334px;
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .top{
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .user {
        flex: 1;
        width: 0;
        display: flex;
        align-items: center;
        .avatar {
          width: 40px;
          height: 40px;
          margin-right: 12px;
          flex-shrink: 0;
        }
        .name {
          font-size: 26px;
          color: #333444;
        }
      }
      .date {
        font-size: 26px;
        color: #999AAA;
        margin-left: 10px;
      }
    }
    .textarea {
      margin: 20px 0;
      font-size: 28px;
      color: #333444;
      .multi-line-omit(3);
    }
  }
  .bottom{
    .icons {
      display: flex;
      align-items: center;
      .item {
        display: flex;
        align-items: center;
        margin-right: 20px;
        .icon {
          width: 32px;
          height: 32px;
        }
        span {
          margin-left: 8px;
          font-size: 24px;
          color: #999AAA;
        }
      }
    }
  }

}
</style>